// extracted by mini-css-extract-plugin
export default {"title":"AtWqJ","container":"VVzfG","container--s":"yEXGX","container--m":"fUEI7","container--l":"AIll1","card":"zL29P","card__image--l":"MBOEc","text":"Zt1jn"};